export default __webpack_public_path__ + "static/media/img1.ed3ae157.png";